var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageTransferWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43.0002,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9845_89019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1789 14.9705C29.0817 15.0562 30.2572 15.3231 31.0886 16.1545C32.3131 17.379 32.3131 19.3497 32.3131 23.2912C32.3131 27.2326 32.3131 29.2035 31.0886 30.4278C29.8642 31.6523 27.8933 31.6523 23.9519 31.6523H19.7713C15.8298 31.6523 13.8591 31.6523 12.6346 30.4278C11.4102 29.2035 11.4102 27.2326 11.4102 23.2912C11.4102 19.3497 11.4102 17.379 12.6346 16.1545C13.598 15.1911 15.0233 14.9857 17.5069 14.9419",
    stroke: "#B28858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4102 21.2017H15.7969C16.5437 21.2017 16.9171 21.2017 17.252 21.3187C17.4565 21.3902 17.6487 21.493 17.8216 21.6236C18.1048 21.8373 18.3119 22.1479 18.7262 22.7694C19.1404 23.3908 19.3476 23.7014 19.6307 23.9152C19.8036 24.0457 19.9958 24.1486 20.2003 24.22C20.5352 24.3371 20.9086 24.3371 21.6555 24.3371H22.0677C22.8146 24.3371 23.188 24.3371 23.5229 24.22C23.7274 24.1486 23.9196 24.0457 24.0925 23.9152C24.3756 23.7014 24.5827 23.3908 24.997 22.7694C25.4113 22.1479 25.6185 21.8373 25.9016 21.6236C26.0745 21.493 26.2667 21.3902 26.4712 21.3187C26.8061 21.2017 27.1795 21.2017 27.9264 21.2017H32.3131",
    stroke: "#B28858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9516 23.9845C23.6574 23.8447 23.3848 23.6669 23.1402 23.4572C22.3574 22.7863 21.8613 21.7904 21.8613 20.6785C21.8613 18.6583 23.4991 17.0205 25.5193 17.0205C27.5396 17.0205 29.1773 18.6583 29.1773 20.6785C29.1773 20.8559 29.1647 21.0304 29.1403 21.2011",
    stroke: "#B28858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7572 19.9923C21.1724 19.3439 20.8164 18.4852 20.8164 17.5433C20.8164 15.523 22.4542 13.8853 24.4744 13.8853C26.4947 13.8853 28.1324 15.523 28.1324 17.5433C28.1324 17.7207 28.1198 17.8952 28.0954 18.0658",
    stroke: "#B28858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9548 19.0914C20.1973 19.0122 19.5086 18.7019 18.9605 18.2321C18.1777 17.5612 17.6816 16.5653 17.6816 15.4534C17.6816 13.4332 19.3194 11.7954 21.3396 11.7954C22.736 11.7954 23.9497 12.5778 24.5661 13.7282",
    stroke: "#B28858",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9845_89019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0835,
    height: 25.0835,
    fill: "white",
    transform: "translate(9.32031 9.31641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTransferWallet);
export default __webpack_public_path__ + "static/media/imageTransferWallet.1778db26eb972ec195809f78ad4d12fd.svg";
export { ForwardRef as ReactComponent };